import React from 'react';

import { Button } from 'flowbite-react';

interface Props {
    readonly containerStyles: string;
    readonly handleBackNavigation: () => void;
    readonly handleContinue: () => void;
    readonly review?: boolean,
    readonly isLoading?: boolean,
    readonly isEdit?: string | boolean,
}

function NavButtons({
    containerStyles,
    handleBackNavigation,
    handleContinue,
    review = false,
    isLoading = false,
    isEdit = false,
}: Props) {
    let buttonText = '';
    if (review) {
        buttonText = 'Publish';
    }
    if (isEdit) {
        buttonText = ' I\'m done!';
    }

    if (!isEdit && !review) {
        buttonText = 'Continue';
    }
    return (
        <div className={`${containerStyles} block sm:flex mb-0 px-0`}>
            {!isEdit
                && (
                    <Button
                        className="w-full sm:w-auto"
                        color="gray"
                        onClick={handleBackNavigation}
                        disabled={isLoading}
                    >
                        Back
                    </Button>
                )}

            <Button
                color="dark"
                className="bg-cleanSlate w-full sm:w-auto mt-2 sm:mt-0"
                onClick={handleContinue}
                isProcessing={isLoading}
                disabled={isLoading}
            >
                {buttonText}
            </Button>

        </div>
    );
}

export default NavButtons;
